import type { LabelGeoJSON, Location } from "~/lib/map/types";

export const locationToLabelGeoJson = ({ label, geoItemId, coords }: Location): LabelGeoJSON => ({
  type: "Feature",
  properties: { label, geoItemId },
  geometry: {
    type: "Point",
    coordinates: [coords.lng, coords.lat],
  },
});
